import { useMemo } from 'react';

import { FULL_SITE_ADDRESS } from '@constants/index';
import Text from '@components/Text';
import Title from '@components/Title';
import s from './StaticContract.module.scss';

const StaticContract = () => {
  const site = FULL_SITE_ADDRESS;
  const ofertaUrl = `${FULL_SITE_ADDRESS}/oferta`;

  const CHAPTERS = useMemo(
    () => [
      {
        title: '1. ОБЩИЕ ПОЛОЖЕНИЯ',
        content: (
          <Text className={s.paragraph} fontgraphik>
            1.1. Настоящий документ является публичной офертой в соответствии с п. 2 ст. 437 Гражданского кодекса РФ и
            содержит все существенные условия по оказанию возмездного оказания услуг, предлагаемой на сайте Исполнителя
            по адресу:{' '}
            <a href={site} rel="noreferrer" target="_blank">
              www.labclick.ru.
            </a>
            <br />
            1.2. Договор считается заключенным между Исполнителем и Клиентом с момента принятия условий (акцепта)
            настоящей Оферты Клиентом.
            <br />
            1.3. Совершая действия по акцепту настоящей Оферты, Клиент подтверждает свою правоспособность и
            дееспособность, а также законное право Клиента вступать в договорные отношения с Исполнителем.
          </Text>
        ),
      },

      {
        title: '2. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ',
        content: [
          {
            title: '2.1. Для целей Договора, нижеперечисленные термины и определения имеют следующие значения:',
            content: (
              <Text className={s.paragraph} fontgraphik>
                2.1.1. <b>Исполнитель</b> - ООО &laquo;ПРОГРЕСС&raquo;.
                <br />
                2.1.2. <b>Сайт</b> - принадлежащий Исполнителю ресурс, размещенный для публичного доступа в интернете по
                адресу:{' '}
                <a href={site} rel="noreferrer" target="_blank">
                  www.labclick.ru.
                </a>
                <br />
                2.1.3. <b>Клиент</b> – дееспособное и совершеннолетнее физическое лицо, имеющее намерение заказать
                (приобрести) либо заказывающее (приобретающее) платные медицинские услуги в соответствии с Договором в
                пользу потребителя услуг. Клиентом является также законный представитель потребителя, действующий от
                имени потребителя в соответствии с действующим российским законодательством. Клиент может являться
                потребителем в случае, если является лицом, получающим платные медицинские услуги по Договору.
                <br />
                2.1.4. <b>Заказ</b> – запрос Клиента на получение услуг, выбранных на сайте.
                <br />
                2.1.5. <b>Цена договора</b> – действующая опубликованная на сайте стоимость услуг.
                <br />
                2.1.6. <b>Личный кабинет</b> – персональный раздел сайта Клиента, доступный для входа только при вводе
                логина и пароля Клиента.
              </Text>
            ),
          },
        ],
      },

      {
        title: '3. ПРЕДМЕТ ДОГОВОРА',
        content: (
          <Text className={s.paragraph} fontgraphik>
            3.1. По настоящему Договору Исполнитель обязуется предоставлять Клиенту платные медицинские услуги (далее —
            &laquo;Медицинские услуги&raquo;), а Клиент обязуется оплачивать оказанные слуги согласно условиям Договора.
            Перечень услуг публикуется на сайте в сети &laquo;Интернет&raquo; по адресу:{' '}
            <a href={site} rel="noreferrer" target="_blank">
              www.labclick.ru.
            </a>
            Перечень услуг является неотъемлемой частью Договора и указывается на Сайте в разделе «Анализы». Заключая
            Договор, Клиент соглашается с Перечнем услуг.
            <br />
            3.2. Конкретный перечень необходимых услуг выбирается Клиентом путем оформления заказа на оказание услуг.
            Заказ может быть оформлен с использованием интерактивной формы заказа на Сайте (далее – «Форма заказа») и
            (или) по номеру телефона, указанному на Сайте. Оформляя заказ любым из перечисленных способов, Клиент
            обязуется указать все запрашиваемые сведения.
            <br />
            После оформления заказа на Медицинские услуги, Клиенту направляется информация о совершенном заказе в виде
            СМС-сообщения на указанный им номер телефона и (или) адрес электронной почты. Информация также отражается в
            Личном кабинете Клиента на Сайте.
            <br />
            3.3. Стоимость услуг по заказу устанавливается Исполнителем и доводится до сведения Клиента непосредственно
            до оказания услуг. Стоимость услуг и порядок оплаты указываются на Сайте в разделе «Анализы». Исполнитель
            имеет право изменить стоимость услуг, о чем своевременно размещает информацию на Сайте, а также в
            прейскуранте цен.
            <br />
            3.4. Исполнитель приступает к оказанию услуг с момента внесения Клиентом предоплаты в порядке, размерах и на
            условиях, определенных настоящим Договором и дополнительными соглашениями к нему (при их наличии).
            <br />
            3.5. Предоставление Медицинских услуг Клиенту осуществляется непосредственно самим Исполнителем, а также с
            привлечением иных специалистов и медицинских учреждений, с которыми у Исполнителя имеются соответствующие
            договоры. Для оказания медицинских услуг по клиническому лабораторному исследованию полученных биоматериалов
            Клиента (услуги по лабораторным исследованиям), Исполнитель вправе привлекать лаборатории. Для оказания
            немедицинских услуг Исполнитель вправе привлекать любых третьих лиц.
            <br />
            3.6. Подписывая Договор, Клиент подтверждает, что уведомлен о том, что несоблюдение указаний (рекомендаций)
            Исполнителя (медицинских работников Исполнителя) могут снизить качество предоставляемых Медицинских услуг,
            повлечь за собой невозможность их завершения в срок или отрицательно сказаться на состоянии здоровья
            Клиента.
          </Text>
        ),
      },

      {
        title: '4. ПРАВА И ОБЯЗАННОСТИ СТОРОН',
        content: [
          {
            title: '4.1. Исполнитель обязан:',
            content: (
              <Text className={s.paragraph} fontgraphik>
                4.1.1. Своевременно и качественно оказывать Медицинские услуги, при оказании Медицинских услуг
                использовать методы, разрешенные к применению российским законодательством и Росздравнадзором;
                <br />
                4.1.2. Обеспечить Клиенту непосредственное ознакомление с медицинской документацией, отражающей
                состояние его здоровья, и выдать по его письменному требованию или письменному требованию его законного
                представителя копии медицинских документов;
                <br />
                4.1.3. Хранить информацию, содержащуюся в медицинских документах Клиента, в тайне (врачебная тайна) и не
                предоставлять ее третьим лицам, за исключением случаев, предусмотренных законодательством Российской
                Федерации;
                <br />
                4.1.4. Вести учет видов, объемов и стоимости оказываемых Клиенту Медицинских услуг;
                <br />
                4.1.5. Сообщать Клиенту о дате и времени предоставления Медицинских услуг по телефону либо путем
                направления СМС-сообщения.
              </Text>
            ),
          },
          {
            title: '4.2. Исполнитель вправе:',
            content: (
              <Text className={s.paragraph} fontgraphik>
                4.2.1. Требовать от Клиента предоставления всей информации, необходимой для качественного и полного
                оказания ему Медицинских услуг;
                <br />
                4.2.2. В случае потенциальной угрозы здоровью Клиента оказать ему медицинские услуги, которые требуются
                в данной ситуации для обеспечения здоровья Клиента;
                <br />
                4.2.3. Требовать от Клиента своевременной оплаты оказанных ему Медицинских услуг;
                <br />
                4.2.4. Не оказывать Медицинские услуги в случаях: если оказание таких услуг с большой степенью
                вероятности может повлечь ухудшение состояния Клиента; если имеются основания, что такие услуги
                противопоказаны Клиенту или могут оказать негативное влияние на его здоровье.
                <br />
                4.2.5. Не оказывать Медицинские услуги Клиенту в случае неоплаты их в установленном Договором порядке
                или наличия задолженности по оплате, за исключением случаев оказания медицинских услуг по экстренным
                показаниям для устранения угрозы жизни Клиента при внезапных острых заболеваниях, состояниях,
                обострениях хронических заболеваний, такие медицинские услуги оказываются без взимания платы в
                соответствии с законодательством Российской Федерации.
                <br />
                4.2.6. Не приступать к оказанию Медицинских услуг Клиенту, находящемуся в состоянии алкогольного,
                токсического или наркотического опьянения, грубо нарушающему режим и условия работы клиники Исполнителя,
                за исключением случаев, когда Клиенту необходимо оказать экстренную медицинскую помощь, в объеме и
                условиях, существующих в клинике.
                <br />
                4.2.7. Изменять прейскурант оказываемых Исполнителем Медицинских услуг по своему усмотрению.
              </Text>
            ),
          },
          {
            title: '4.3. Клиент обязан:',
            content: (
              <Text className={s.paragraph} fontgraphik>
                4.3.1. Предоставить Исполнителю информацию о себе: подтвержденный диагноз, включая сведения о
                перенесенных заболеваниях и имеющихся заболеваниях, операциях, травмах, о проведенных ранее
                обследованиях, и лечении, об аллергических реакциях, которые могут сказаться на качестве оказываемых
                Исполнителем Медицинских услуг;
                <br />
                4.3.2. Находиться в установленное время по указанному им адресу для оказания Медицинских услуг, согласно
                предварительной записи;
                <br />
                4.3.3. В период оказания Медицинских услуг неукоснительно выполнять все требования Исполнителя,
                касающиеся оказания Медицинских услуг;
                <br />
                Требования выполнения режима после завершения оказания Медицинских услуг включают в себя, но не
                ограничиваются обязанностью Клиента воздержаться от действий:
                <br />
                - перелетов авиатранспортом на 24 часа;
                <br />
                - приема антибиотиков, сульфаниламидных и гормональных препаратов на 10 дней (кроме приема препаратов по
                жизненным показаниям);
                <br />
                - курения на 10 дней;
                <br />
                - употребления алкоголя на 1 месяц;
                <br />
                - физических нагрузок, активных занятий спортом на 10 дней;
                <br />
                - физиотерапии на 10 дней;
                <br />
                - посещений массажа, бани, сауны на 10 дней;
                <br />
                - пребывания на открытом солнце и посещения солярия на 1 месяц;
                <br />
                - рентгенологических обследований, МРТ, КТ, СКТ на 2 месяца;
                <br />
                - любых оперативных вмешательств, с применением общего наркоза или местной анестезии (в т.ч.
                стоматологических) на 2 месяца.
                <br />
                4.3.4. В случае возникновения осложнений после оказания Медицинских услуг (любого из его этапов)
                обратиться, в первую очередь, к Исполнителю;
                <br />
                4.3.5. Своевременно и в полном объеме оплачивать оказанные ему Исполнителем Медицинские услуги;
                <br />
                4.3.6. Извещать Исполнителя о смене адреса проживания Клиента, а также о замене доверенного лица (при
                его наличии) до заказа медицинских услуг.
                <br />
                4.3.7. Надлежащим образом исполнять условия настоящего Договора и своевременно информировать Исполнителя
                о любых обстоятельствах, препятствующих исполнению Клиентом условий настоящего Договора.
              </Text>
            ),
          },
          {
            title: '4.4. Клиент вправе:',
            content: (
              <Text className={s.paragraph} fontgraphik>
                4.4.1. Получать достоверную и полную информацию о состоянии своего здоровья, включая сведения о
                результатах обследования, наличии заболевания, его диагнозе и прогнозе.
                <br />
                4.4.2. Непосредственно знакомиться с медицинской документацией, отражающей состояние его здоровья,
                получать копии медицинских документов, отражающих состояние его здоровья.
                <br />
                4.4.3. Требовать от Исполнителя предоставления сведений о наличии лицензии, квалификации врачей,
                стоимости оказываемых услуг.
                <br />
                4.4.4. Отказаться от медицинского вмешательства (в письменной форме).
                <br />
                4.4.5. Требовать сохранения конфиденциальности информации о факте обращения за медицинской помощью,
                диагнозе, состоянии здоровья (врачебной тайны).
              </Text>
            ),
          },
        ],
      },

      {
        title: '5. УСЛОВИЯ ОКАЗАНИЯ УСЛУГ',
        content: (
          <Text className={s.paragraph} fontgraphik>
            5.1. Необходимым предварительным условием медицинского вмешательства является информированное добровольное
            согласие Клиента, которое составляется в виде отдельного документа, подписывается Клиентом и в дальнейшем
            хранится в медицинской карте Клиента.
            <br />
            При выявлении Исполнителем в ходе обследования иных заболеваний, которые могут существенно повлиять на
            качество проводимого лечения, Исполнитель обязан предупредить об этом Клиента, указав возможные
            дополнительные осложнения в тексте добровольного информированного согласия.
            <br />
            5.2. Третьи лица, привлекаемые Исполнителем для оказания Медицинских услуг в соответствии с пунктом 4.2.3.
            настоящего Договора, должны обладать необходимыми разрешениями на оказание соответствующих Медицинских
            услуг, а также необходимыми знаниями и квалификацией.
            <br />
            При привлечении Исполнителем для оказания Медицинских услуг Клиенту (или указанным им лицам) третьих лиц
            Исполнитель обязан довести до сведения Клиента всю необходимую информацию о третьем лице, а также информацию
            о времени и месте оказания Клиенту (или указанным им лицам) данных Медицинских услуг.
            <br />
            5.3. Сроки оказания Медицинских услуг указан в перечне услуг. В случае необходимости срок оказания
            Медицинских услуг определяется Исполнителем дополнительно с учетом индивидуальных особенностей Клиента и
            указывается в памятке, выдаваемой Клиенту при заключении настоящего Договора.
            <br />
            5.4. Забор биоматериала в целях оказания Услуг по лабораторным исследованиям осуществляется по адресу
            Клиента и в период времени, указанный им в заказе. Время и территория, доступные для вывоза Исполнителя в
            целях забора биоматериала указывается на Сайте.
            <br />
            5.5. Заключая настоящий Договора, Клиент дает согласие на передачу биоматерилов в лаборатории в целях
            оказания услуг по лабораторным исследованиям.
          </Text>
        ),
      },

      {
        title: '6. ПОРЯДОК И СРОКИ ОПЛАТЫ',
        content: (
          <Text className={s.paragraph} fontgraphik>
            6.1. Общая сумма стоимости Медицинских услуг, указанных в Договоре, определяется по сумме всех оказанных
            Медицинских услуг за период действия настоящего Договора.
            <br />
            6.2. Клиент обязуется оплачивать Медицинские услуги в порядке и в сроки, указанные в Договору и на Сайте.
            <br />
            6.3. Оплата Медицинских услуг, оказанных Клиенту Исполнителем, производится в российских рублях безналичным
            расчетом по банковской карте на основании выставленного счета.
            <br />
            6.4. Клиент вправе отказаться от исполнения Договора при условии направления соответствующего
            предварительного уведомления об отказе в адрес Исполнителя и оплаты Исполнителю фактически оказанных
            Медицинских услуг.
          </Text>
        ),
      },

      {
        title: '7. КОНФИДЕНЦИАЛЬНАЯ ИНФОРМАЦИЯ',
        content: (
          <Text className={s.paragraph} fontgraphik>
            7.1. Исполнитель обязуется хранить в тайне информацию о факте обращения Клиента за медицинской помощью,
            состоянии здоровья Клиента, его диагнозе и иные сведения, полученные Исполнителем при обследовании Клиента и
            его лечении в соответствии с законодательством Российской Федерации.
            <br />
            7.2. С согласия Клиента или его законного представителя допускается передача сведений, составляющих
            врачебную тайну, третьим лицам.
          </Text>
        ),
      },

      {
        title: '8. ОТВЕТСТВЕННОСТЬ СТОРОН',
        content: (
          <Text className={s.paragraph} fontgraphik>
            8.1. Стороны несут ответственность за неисполнение или ненадлежащее исполнение обязательств по настоящему
            Договору в соответствии с законодательством Российской Федерации, в том числе Исполнитель несет
            ответственность в соответствии с действующим законодательством о защите прав потребителей и Правилами
            предоставления медицинским организациям платных медицинских услуг, утвержденными Постановлением
            Правительства РФ от 04.10.2012 № 1006.
            <br />
            8.2. Исполнитель не несет ответственности за качество Медицинских услуг в случае нарушения Клиентом
            обязанностей, установленных в пунктах 4.3 настоящего Договора.
            <br />
            8.3. Клиент самостоятельно обеспечивает исполнение требований, связанных с соблюдением режима после
            завершения оказания Медицинских услуг, установленных в пунктах 4.3.3. В случае нарушения Клиентом указанных
            требований Исполнитель не несет ответственность за возможные неблагоприятные последствия и осложнения.
            <br />
            8.4. Исполнитель не несет ответственности перед Клиентом за негативные последствия в случае несвоевременного
            обращения за получением медицинской помощи. Исполнитель не несет ответственности за осложнения и другие
            побочные эффекты медицинского вмешательства в рамках оказания Медицинских услуг по настоящему Договору,
            возникшие вследствие биологических особенностей организма Клиента, вероятность которых используемые знания и
            технологии не могут полностью исключить.
            <br />
            8.5. Исполнитель не несет ответственности за оказание Медицинских услуг в неполном либо меньшем объеме, чем
            предусмотрено Договором, в случаях предоставления Клиентом неполной и (или) недостоверной информации о своем
            здоровье.
            <br />
            8.6. Исполнитель освобождается от ответственности за неисполнение или ненадлежащее исполнение Договора, в
            том числе за качество оказываемых по Договору Медицинских услуг, в случае несоблюдения Клиентом указаний
            (рекомендаций) Исполнителя (медицинских работников), в том числе назначенного режима лечения и приема
            лекарств.
            <br />
            8.7. Стороны освобождаются от ответственности за частичное или полное неисполнение или ненадлежащее
            исполнение обязательств по настоящему Договору, если оно явилось следствием обстоятельств непреодолимой силы
            или результатом препятствия, находящегося вне контроля Сторон.
          </Text>
        ),
      },

      {
        title: '9. ОБСТОЯТЕЛЬСТВА НЕПРЕОДОЛИМОЙ СИЛЫ (ФОРС-МАЖОР)',
        content: (
          <Text className={s.paragraph} fontgraphik>
            9.1. Сторона, не исполнившая или ненадлежащим образом исполнившая обязательство по настоящему Договору,
            будет освобождена от ответственности в случае, если такое неисполнение или ненадлежащее исполнение произошло
            в результате наступления чрезвычайных и непредотвратимых при данных условиях обстоятельств, то есть
            обстоятельств непреодолимой силы, за наступление которых ни одна из Сторон не отвечает и которые Стороны не
            могли и не должны были предвидеть и не смогли предотвратить, несмотря на предпринятые Сторонами попытки их
            предотвращения (пожары, наводнения, ураганы, военные действия).
            <br />
            Надлежащим доказательством наличия указанных обстоятельств и их продолжительности будут служить справки,
            выдаваемые соответствующими компетентными органами Российской Федерации.
            <br />
            9.2. Обстоятельства непреодолимой силы, указанные в пункте 9.1 настоящего Договора, освобождают Сторону от
            ответственности, если они наступили после заключения настоящего Договора.
            <br />
            9.3. Сторона, попавшая под действие обстоятельств непреодолимой силы, обязана в течение 24 (двадцати
            четырех) часов в письменной форме уведомить другую Сторону о наступлении и возможной продолжительности
            действия обстоятельств непреодолимой силы в том случае, если, исходя из конкретных обстоятельств,
            соответствующая Сторона имеет возможность направить такое уведомление.
            <br />
            Сторона, не исполнившая указанную обязанность, лишается права ссылаться на действие в отношении нее
            непреодолимой силы и не освобождается от ответственности за неисполнение или ненадлежащее исполнение своих
            обязательств по Договору.
            <br />
            9.4. В случае возникновения обстоятельств непреодолимой силы, предусмотренных пунктом 9.1 настоящего
            Договора, сроки исполнения Сторонами своих обязательств по настоящему Договору увеличиваются на срок
            существования соответствующих обстоятельств.
          </Text>
        ),
      },

      {
        title: '10. РАССМОТРЕНИЕ СПОРОВ',
        content: (
          <Text className={s.paragraph} fontgraphik>
            10.1. Для сторон настоящего договора обязателен претензионный порядок урегулирования споров. Претензия
            должна быть оформлена в письменном виде с указанием причины, вызвавшей необходимость обращения.
            <br />
            10.2. Сторона, получившая претензию, обязана дать письменный ответ в течение 15 (пятнадцати) рабочих дней с
            даты ее получения. При возникновении разногласий Сторон в оценке качества предоставленных Медицинских услуг,
            к рассмотрению принимаются только претензии Клиента (Потребителя) официально подтвержденные документами иных
            медицинских учреждений.
            <br />
            10.3. В случае невозможности урегулирования спора путем переговоров спор подлежит разрешению в судебном
            порядке в соответствии с правилами о подведомственности и подсудности, установленными законодательством
            Российской Федерации.
            <br />
            10.4. Все разногласия, возникшие при исполнении Договора, в связи с ним или в результате его исполнения
            Стороны разрешают путем переговоров. В случае не достижения Сторонами соглашения, спор передается на
            рассмотрение в Арбитражный суд по месту нахождения Исполнителя.
          </Text>
        ),
      },

      {
        title: '11. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ',
        content: (
          <Text className={s.paragraph} fontgraphik>
            11.1. Заключая Договор, Клиент дает согласие на&nbsp;обработку персональных данных по&nbsp;форме, указанной
            в&nbsp;Приложении №&nbsp;1&nbsp;к Договору, в&nbsp;соответствии с&nbsp;Политикой конфиденциальности
            и&nbsp;Пользовательским соглашением, размещенными на&nbsp;Сайте:{' '}
            <a href={site} rel="noreferrer" target="_blank">
              www.labclick.ru.
            </a>
            &nbsp;Настоящим Клиент (если он&nbsp;является уполномоченным представителем потребителя Услуг) гарантирует,
            что получил от&nbsp;потребителя, для которого заказываются Услуги, необходимое согласие Исполнителю
            и&nbsp;привлеченным им&nbsp;лицам на&nbsp;обработку персональных данных.
            <br />
            11.2. Исполнитель вправе изменять условия настоящей Оферты (Договора) в одностороннем порядке. Датой
            вступления в силу изменений настоящей Оферты является дата их опубликования на Сайте Исполнителя. При этом,
            ранее оплаченные услуги предоставляются Клиенту в полном объеме на условиях, действовавших на момент оплаты.
            <br />
            11.3. Не вступая в противоречие с условиями настоящей Оферты, Стороны вправе в любое время оформить договор
            на оказание услуг в форме письменного двухстороннего документа.
            <br />
            11.4. Стороны признают, что копии заверенных документов, связанных с настоящей Офертой, переданные по
            электронным каналам связи, приравниваются к оригиналам до момента получения Сторонами оригинальных
            экземпляров соответствующих документов.
          </Text>
        ),
      },

      {
        title: '12. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ:',
        content: (
          <>
            <div className={s.contractRequisites}>
              <div className={s.contractRequisitesCol}>
                <Text className={s.contractRequisitesText} weight="medium" fontgraphik>
                  ООО «ПРОГРЕСС»
                </Text>
                <Text className={s.contractRequisitesText} fontgraphik>
                  <b>ОГРН:</b> 5147746155519
                </Text>
                <Text className={s.contractRequisitesText} fontgraphik>
                  <b>ИНН/КПП:</b> 7714946124/774301001
                </Text>
                <Text className={s.contractRequisitesText} fontgraphik>
                  <b>Юрид. и факт. адрес:</b> 125565, г. Москва, ул. Фестивальная, д. 13, корп. 2
                </Text>

                <div className={s.contractRequisitesChapter}>
                  <Text className={s.contractRequisitesTitle} weight="medium">
                    Банковские реквизиты:
                  </Text>
                  <Text className={s.contractRequisitesText} fontgraphik>
                    <b>Банк:</b> АО «АЛЬФА-БАНК»
                  </Text>
                  <Text className={s.contractRequisitesText} fontgraphik>
                    <b>Р/с:</b> 40702810202370006207
                  </Text>
                  <Text className={s.contractRequisitesText} fontgraphik>
                    <b>БИК:</b> 044525593
                  </Text>
                  <Text className={s.contractRequisitesText} fontgraphik>
                    <b>К/с:</b> 30101810200000000593
                  </Text>
                  <Text className={s.contractRequisitesText} fontgraphik>
                    <b>Тел.:</b> 8-495-155-15-55
                  </Text>
                  <Text className={s.contractRequisitesText} fontgraphik>
                    <b>Эл. почта:</b> info@labclick.ru
                  </Text>
                </div>
              </div>
            </div>
          </>
        ),
      },
    ],
    [site]
  );

  return (
    <>
      <div className={s.chapterMain}>
        <Title className={s.title} level={1}>
          Оферта на заключение договора возмездного оказания медицинских услуг
        </Title>

        <Text className={s.paragraph} fontgraphik>
          Общество с&nbsp;ограниченной ответственностью &laquo;ПРОГРЕСС&raquo; (далее по тексту – Исполнитель),
          настоящей публичной офертой (далее – &laquo;Оферта&raquo;) предлагает заключить договор возмездного оказания
          медицинских услуг (далее – &laquo;Договор&raquo;).
          <br />
          Акцептовав настоящую оферту, Вы (Клиент) заключаете договор возмездного оказания медицинских услуг на
          условиях, в порядке и объеме, определенных настоящей офертой, опубликованной по электронному адресу:{' '}
          <a href={ofertaUrl} rel="noreferrer" target="_blank">
            {ofertaUrl}.
          </a>
          <br />
          Моментом полного и безоговорочного принятия Клиентом предложения Исполнителя заключить договор оферты
          (акцептом оферты) считается факт заполнения и отправки Клиентом заказа Исполнителю.
        </Text>
      </div>

      {CHAPTERS.map((chapter) => (
        <div key={chapter.title} className={s.chapter}>
          <Title level={2}>{chapter.title}</Title>

          {Array.isArray(chapter.content)
            ? chapter.content.map((chapterContentPart) => (
                <div key={chapterContentPart.title}>
                  <Text className={s.chapterSubTitle} size="large">
                    {chapterContentPart.title}
                  </Text>

                  <Text className={s.paragraph} fontgraphik>
                    {chapterContentPart.content}
                  </Text>
                </div>
              ))
            : chapter.content}
        </div>
      ))}
    </>
  );
};

export default StaticContract;
